var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10C10.1218 10 9.36146 10.4327 8.83631 11.0696C8.31126 11.7063 8 12.567 8 13.5C8 14.433 8.31126 15.2937 8.83631 15.9304C9.36146 16.5673 10.1218 17 11 17C11.8782 17 12.6385 16.5673 13.1637 15.9304C13.6887 15.2937 14 14.433 14 13.5C14 12.567 13.6887 11.7063 13.1637 11.0696C12.6385 10.4327 11.8782 10 11 10ZM8.91228 13.5C8.91228 12.7292 9.17048 12.0473 9.56613 11.5674C9.96168 11.0877 10.4733 10.8298 11 10.8298C11.5267 10.8298 12.0383 11.0877 12.4339 11.5674C12.8295 12.0473 13.0877 12.7292 13.0877 13.5C13.0877 14.2708 12.8295 14.9527 12.4339 15.4326C12.0383 15.9123 11.5267 16.1702 11 16.1702C10.4733 16.1702 9.96168 15.9123 9.56613 15.4326C9.17048 14.9527 8.91228 14.2708 8.91228 13.5Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7474 0.706731V6.73077H21.2822C21.6786 6.73077 22 7.04718 22 7.4375V20.2933C22 20.6836 21.6786 21 21.2822 21H0.717772C0.321356 21 0 20.6836 0 20.2933V7.4375C0 7.04718 0.321358 6.73077 0.717772 6.73077H5.25256V0.706731C5.25256 0.316414 5.57392 0 5.97034 0H16.0297C16.4261 0 16.7474 0.316413 16.7474 0.706731ZM6.07287 6.73077V0.807692H15.9271V6.73077H6.07287ZM0.820311 20.1923V7.53846H21.1797V20.1923H0.820311Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d25fa01b.svg";
export { ForwardRef as ReactComponent };